import {Component, ElementRef, OnInit, ViewChild, ViewEncapsulation} from '@angular/core';
import {LoginService} from './login.service';
import {ActivatedRoute, Router} from '@angular/router';
import {User} from '../auth/user.model';
import {AuthService} from '../auth/auth.service';
import {OktaAuthService} from '../auth/okta-auth.service';
import {SnackBarService} from '../services/snackbar.service';
import {GlobalSpinnerService} from '../services/global-spinner.service';
import {Principal} from '../auth/principal.service';

@Component({
  selector: 'ctv-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class LoginComponent implements OnInit {

  @ViewChild('username', { static: false }) vc: ElementRef;

  user: User = new User();
  registerLinkVisible = false;
  oktaSsoEnabled = false;
  private returnUrl: any | string;

  constructor(private loginService: LoginService,
              private router: Router,
              private route: ActivatedRoute,
              private authService: AuthService,
              private oktaAuthService: OktaAuthService,
              private principal: Principal,
              private snackBarService: SnackBarService,
              private globalSpinnerService: GlobalSpinnerService) {
  }

  ngOnInit() {
    console.log('Login Init');
    this.oktaSsoEnabled = this.oktaAuthService.isEnabled();
    if (window.document.location.origin.includes('ctvbuyer')) {
      window.document.getElementById('appFavicon').setAttribute('href', 'assets/favicons/favicon-3.png');
      window.document.title = 'CTVBuyer';
    }
    this.route.queryParams.subscribe(next => {
      this.returnUrl = this.route.snapshot.queryParams.returnUrl || null;
    });

    const oktaError = sessionStorage.getItem('okta_login_error');
    if (oktaError) {
      sessionStorage.removeItem('okta_login_error');
      this.snackBarService.error(oktaError);
    }
    // Don't redirect/clear while an Okta code is still in the URL.
    // Callback is handled by APP_INITIALIZER; if we already have a session, enter the app.
    if (!this.oktaAuthService.hasPendingCallback() && this.authService.isAuthenticated()) {
      this.navigate(['/dashboard']);
    }
  }

  public login() {
    this.globalSpinnerService.showLoader();
    this.loginService.login(this.user)
      .then((user: User) => {
        user.roles.length > 1 ? this.navigate(['/select']) : this.navigate(['/dashboard']);
        this.globalSpinnerService.hideLoader();
      }).catch((error) => {
      console.error(error);
      this.globalSpinnerService.hideLoader();
      this.snackBarService.error('Invalid credentials');
    });
  }

  public loginWithOkta() {
    this.globalSpinnerService.showLoader();
    this.oktaAuthService.startLogin(this.returnUrl)
      .catch((error) => {
        console.error(error);
        this.globalSpinnerService.hideLoader();
        this.snackBarService.error(error?.message || 'Unable to start Okta login');
      });
  }

  private navigate(location) {
    if (this.returnUrl) {
      this.router.navigateByUrl(this.returnUrl);
    } else {
      this.router.navigate(location);
    }
  }
}
